module.exports = __webpack_public_path__ + "static/media/Marina.aad13e66.jpg";